import { render, staticRenderFns } from "./TkGlobalModal.vue?vue&type=template&id=8e9ec90c&"
import script from "./TkGlobalModal.vue?vue&type=script&lang=js&"
export * from "./TkGlobalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports